import { createConsentControlledVendor, readConfiguredValue } from './consentControlledVendor'

const META_PIXEL_SCRIPT_ATTRIBUTE = 'data-professionals-meta-pixel'
const META_PIXEL_SCRIPT_URL = 'https://connect.facebook.net/en_US/fbevents.js'

type MetaPixelCall = Parameters<NonNullable<Window['fbq']>>
type MetaPixelQueue = NonNullable<Window['fbq']> & {
  callMethod?: (this: MetaPixelQueue, ...args: MetaPixelCall) => void
  loaded: boolean
  push: MetaPixelQueue
  queue: MetaPixelCall[]
  version: string
}

function createMetaPixelQueue() {
  const fbq = ((...args: MetaPixelCall) => {
    if (fbq.callMethod) fbq.callMethod.call(fbq, ...args)
    else fbq.queue.push(args)
  }) as MetaPixelQueue

  fbq.loaded = true
  fbq.push = fbq
  fbq.queue = []
  fbq.version = '2.0'
  window.fbq = fbq
  window._fbq = fbq
}

const metaPixel = createConsentControlledVendor({
  scriptAttribute: META_PIXEL_SCRIPT_ATTRIBUTE,
  resolveConfiguration: () => readConfiguredValue(import.meta.env.VITE_META_PIXEL_ID),
  isQueueAvailable: () => typeof window.fbq === 'function',
  createQueue: createMetaPixelQueue,
  grantConsent: () => {
    window.fbq?.('consent', 'grant')
  },
  revokeConsent: () => {
    window.fbq?.('consent', 'revoke')
  },
  initialize: (pixelId) => {
    window.fbq?.('init', pixelId)
  },
  resolveScriptUrl: () => META_PIXEL_SCRIPT_URL,
})

export const configureMetaPixel = metaPixel.configure
export const revokeMetaPixelConsent = metaPixel.revokeConsent
